import React from "react";
function AboutEnglish() {
	return (
		<div>
			<p style={{ marginBottom: 10 }}>
				Hi! <span>👋</span> I’m Estefanía, I am a frontend developer{" "}
				<span>👩🏻‍💻</span> with over four years of experience, working with
				technologies such as HTML, CSS, JavaScript, and React.<br/> I am passionate
				about creating smooth and engaging user experiences, focusing on both
				functionality and web interface design.
			</p>
			<p style={{ marginBottom: 10 }}>
				My background in Art History and Cultural Management has given me a
				unique perspective, allowing me to combine aesthetics and creativity
				with technical problem-solving something I consider a essential skill in
				web development.
			</p>
			<p style={{ marginBottom: 10 }}>
				Throughout my career, I have worked on real-world projects that have
				allowed me to further refine my skills and learn from everyday
				challenges.<br/> My goal is to continue growing as a professional and contribute to the
				development of innovative web solutions.
			</p>
			<p>
				The projects shown in this portfolio mainly correspond to the early
				stages of my career as a developer (2020-2021). <br/> Since then, I have
				worked on professional projects within development teams whose code and
				implementation are not publicly available.
			</p>
		</div>
	);
}

export default AboutEnglish;
